
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from "./components/ScrollToTop";
import ChatwootWidget from "./components/ChatwootWidget";
import ClarityAnalytics from "./components/ClarityAnalytics";
import MetaPixel from "./components/MetaPixel";
import GoogleAnalytics from "./components/GoogleAnalytics";
import ErrorBoundary from "./components/ErrorBoundary";
import Index from "./pages/Index";
import BoletoParcelado from "./pages/BoletoParcelado";
import Antecipacao from "./pages/Antecipacao";
import CadastroExpress from "./pages/CadastroExpress";
import AcessePortais from "./pages/AcessePortais";
import NotFound from "./pages/NotFound";
import Sobre from "./pages/Sobre";
import Atendimento from "./pages/Atendimento";
import Faq from "./pages/Faq";

const queryClient = new QueryClient();

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <ScrollToTop />
            <MetaPixel />
            <GoogleAnalytics />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/boleto-parcelado" element={<BoletoParcelado />} />
              <Route path="/antecipacao" element={<Antecipacao />} />
              <Route path="/cadastro-express" element={<CadastroExpress />} />
              <Route path="/acesse-portais" element={<AcessePortais />} />
              <Route path="/sobre" element={<Sobre />} />
              <Route path="/atendimento" element={<Atendimento />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <ChatwootWidget />
            <ClarityAnalytics />
          </BrowserRouter>
        </TooltipProvider>
      </HelmetProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
